import { Component, Input } from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-simulation-form-shell',
  standalone: true,
  imports: [FontAwesomeModule],
  templateUrl: './simulation-form-shell.component.html',
  styleUrls: ['./simulation-form-shell.component.scss'],
})
export class SimulationFormShellComponent {
  @Input() loading = false;

  readonly spinnerIcon = faSpinner;
}
